import React from 'react'
import {DragSource} from 'react-dnd'
import {getEmptyImage} from 'react-dnd-html5-backend'

import EditorOverlayDragButton from './EditorOverlayDragButton'

const elementSource = {
  beginDrag(props, monitor, component) {
    props.onDragStart()
    return {
      itemType: 'module',
      moduleId: props.moduleId,
      label: 'Modul'
    }
  },
  endDrag(props, monitor, component) {
    props.onDragEnd()
  }
}

function elementCollect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }
}

class EditorOverlayDragButtonSourceModule extends React.Component {
  componentDidMount() {
    const {connectDragPreview} = this.props
    connectDragPreview(getEmptyImage())
  }

  render() {
    return this.props.connectDragSource(
      <div className="drag-button-source">
        <EditorOverlayDragButton />
      </div>
    )
  }
}

export default DragSource(
  'module',
  elementSource,
  elementCollect
)(EditorOverlayDragButtonSourceModule)
